import React from 'react';
import styled from 'styled-components';
import { Switch } from 'tdesign-react';

export default function SystemSwitchAppend(props) {
  return (
    <Root>
      展示系统Topic
      <Switch style={{ margin: '0 10px 0 8px' }} {...props} />
    </Root>
  );
}

const Root = styled.div`
  color: #202b40;
  font-size: 12px;
  font-style: normal;
  display: flex;
  align-items: center;
  height: 32px;
`;
